import dateFormat from '@utils/dateformat';
import PropTypes from 'prop-types';
import React from 'react';
import { getMonth, getYear } from 'date-fns';

type ProposalDateProps = {
  startDate: Date,
  endDate: Date
};


const ProposalDate: React.FC<ProposalDateProps> = ({ startDate, endDate }) => {

  const sm = getMonth(startDate);
  const em = getMonth(endDate);
  const sy = getYear(startDate);
  const ey = getYear(endDate);

  let _dateFormat: JSX.Element | null = null;

  if (sy === ey) {
    if (sm === em) {
      _dateFormat = <> {dateFormat(startDate, "dd")}-{dateFormat(endDate, "dd mmmm yyyy")} </>
    } else {
      _dateFormat = <> {dateFormat(startDate, "dd mmmm")}-{dateFormat(endDate, "dd mmmm yyyy")} </>
    }
  } else {
    _dateFormat = <> {dateFormat(startDate, "dd mmmm yyyy")}-{dateFormat(endDate, "dd mmmm yyyy")} </>
  }

  return _dateFormat
}

ProposalDate.propTypes = {
  //
};

export default ProposalDate;
